module.exports = __webpack_public_path__ + "static/media/ouzeria_thumb_even.5104b507.jpg";